import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import toast from 'react-toastify'
import { SimpleFetch, store } from '../../../../../_helpers'
import { Loader } from '../../../../../_components'

export const AbandonFields = (props) => {
  const [ categories, setCategories ] = useState([])
  const [ loading, setLoading ] = useState(true)

  useEffect(() => {
    async function requestAvailableCategories() {
      const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/event/${store.getState().changeDomainReducer.selectedDomain.domain_uuid}`);
      if ( req.status !== 200 ) {
        return toast.error("Ocorreu um erro ao listar as categorias disponíveis. Tente novamente mais tarde.", { position: toast.POSITION.TOP_RIGHT, className: 'toast-error' });
      }

      if ( req.data || req.data.length !== 0 ) {
        const arr = props.localData.trigger ? props.localData.trigger : []
        props.setLocalData({...props.localData, trigger: {...arr, "comparation": "contain"}})
      }

      setCategories(req.data.map(a => {return {label: a.parent_category, value: a.uuid}}))
      setLoading(false)
    }

    requestAvailableCategories();
  }, []);

  const handleCategoryChange = async (e, key) => {
    const arr = props.localData.trigger ? props.localData.trigger : [];
    
    if ( !e )
      return props.setLocalData({...props.localData, trigger: {...arr, [key]: ""}})

    props.setLocalData({...props.localData, trigger: {...arr, [key]: e.label}})
  }

  const handleChange = async (e, key) => {
    if ( !e || !e.value ) return

    const arr = props.localData.trigger ? props.localData.trigger : []
    
    if ( key !== "interval" )
      return props.setLocalData({...props.localData, trigger: {...arr, [key]: e.value}})

    const toSeconds = {
      "A": 31536000,
      "M": 2592000,
      "D": 86400,
      "h": 3600,
      "m": 60,
      "s": 1
    }

    const values = e.value.split(' ')
    const parsedValues = values.map(value => {
      let regex = value.match(/[a-z]+|[^a-z]+/gi)
      if ( !regex ) return 0
      
      let regexedValue = regex[0]
      let multiplier = toSeconds[regex[1]]
      let totalSeconds = multiplier * regexedValue

      if ( isNaN(totalSeconds) ) return 0
      return totalSeconds
    });

    const value = parsedValues.reduce((a, b) => a + b, 0).toString()
    return props.setLocalData({...props.localData, trigger: {...arr, [key]: value}})
  }

  return (
    <>
      {
        !loading || categories.length !== 0 ? 
          <>
            <div className="titled__group">
              <p>1ª Condição:</p>
              <Select
                options={[
                  {label: "Contém", value: "contain"},
                ]}
                className="basic-select"
                classNamePrefix="select"
                placeholder="Selecione"
                onChange={(e) => handleChange(e, "comparation")}
                defaultValue={{label: "Contém", value: "contain"}}
                isDisabled
              />
            </div>
            <div className="titled__group">
              <p>1º Parâmetro:</p>
              <CreatableSelect
                className="basic-select"
                options={categories}
                isClearable
                onChange={(e) => handleCategoryChange(e, "parentCategory")}
                placeholder="Selecione ou insira"
              />
            </div>
            <div className="titled__group">
              <p>2ª Condição:</p>
              <Select
                options={[
                  {label: "Contém", value: "contain"},
                  {label: "Não contém", value: "notcontain"}
                ]}
                className="basic-select"
                classNamePrefix="select"
                placeholder="Selecione"
                onChange={(e) => handleChange(e, "comparation2")}
              />
            </div>
            <div className="titled__group">
              <p>2º Parâmetro:</p>
              <Select
                options={categories}
                className="basic-select"
                classNamePrefix="select"
                placeholder="Selecione"
                onChange={(e) => handleCategoryChange(e, "parentCategory2")}
              />
            </div>
            <div className="titled__group">
              <p>Intervalo:</p>
              <input type="text" className="basic-input" placeholder="Ex.: 1D 2h 30m" onChange={(e) => handleChange(e.target, "interval")}/>
            </div>
          </>
        : <div className="titled__group">
            <Loader className="relative in-block is-blue" />
          </div>
      }
    </>
  )
}